import { format, parse, parseISO, isValid } from 'date-fns';
import StringHelper from './string-helper';

// Converte tokens de formato do moment (ex.: DD/MM/YYYY) para date-fns
// (dd/MM/yyyy): D→d (dia), Y→y (ano); M (mês) é igual nas duas libs.
export const toDateFnsToken = momentToken =>
  momentToken.replace(/D/g, 'd').replace(/Y/g, 'y');

const DateTimeHelper = {
  isUnformattedDate: date => {
    return (
      StringHelper.isNotEmpty(date) &&
      new RegExp(/^(\d{4})-(\d{2})-(\d{2})$/).test(date.toString())
    );
  },

  toDisplay: (date, t) => {
    if (DateTimeHelper.isUnformattedDate(date)) {
      return format(parseISO(date), toDateFnsToken(t('calendar.dateFormat')));
    }

    return '';
  },

  formatDate: date => {
    if (!date) {
      return date;
    }
    // tenta parsear nos formatos DD-MM-YYYY / DD/MM/YYYY; se válido, normaliza
    // para YYYY-MM-DD; senão devolve o valor original (mesmo comportamento que
    // antes, com moment).
    const parsed = ['dd-MM-yyyy', 'dd/MM/yyyy']
      .map(fmt => parse(date.toString(), fmt, new Date()))
      .find(d => isValid(d));

    return parsed ? format(parsed, 'yyyy-MM-dd') : date;
  },
};

export default DateTimeHelper;
